import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useCatalogueContext } from '../../CatalogueContext';
import Slider from '@mui/material/Slider';
import { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import IconButton from '@mui/material/IconButton';
import {
  DeleteIcon,
  ZoomInIcon,
  VisibilityIcon,
  VisibilityOffIcon,
} from '../../../../globals/icons';
import { Divider } from '@mui/material';

export function WmsCard({ wms }: any) {
  const [opacity, setOpacity] = useState(80);
  const [isVisible, setIsVisible] = useState(true);

  const { viewerRef, setLayersDisplayed, layersDisplayed } =
    useCatalogueContext();

  const imageryLayers = viewerRef.current.cesiumElement.imageryLayers._layers;

  const handleChange = (newValue: number, event: any) => {
    event.stopPropagation();
    setOpacity(newValue);
    let layer = imageryLayers.find((x: any) => x.imageryProvider.id === wms.id);
    layer.alpha = newValue / 100;
  };

  const zoomTo = (e: any) => {
    e.stopPropagation();
    const viewer = viewerRef.current.cesiumElement;
    viewer.camera.flyTo({ destination: wms.rectangle });
  };

  const handleVisibility = (e: any) => {
    e.stopPropagation();
    setIsVisible(!isVisible);
    if (imageryLayers.some((x: any) => x.imageryProvider.id === wms.id)) {
      let layer = imageryLayers.find(
        (x: any) => x.imageryProvider.id === wms.id,
      );
      layer.show = !layer.show;
    }
  };

  const handleCollapse = () => {
    setLayersDisplayed((prevLayers) => {
      const updatedLayers = prevLayers.map((layer) => {
        if (layer.id === wms.id) {
          return { ...layer, isExpanded: !layer.isExpanded };
        }
        return layer;
      });
      return updatedLayers;
    });
  };
  const removeLayer = async (e: any, wms: any) => {
    e.stopPropagation();
    await viewerRef;

    const { cesiumElement } = viewerRef.current;
    const isFound = cesiumElement.imageryLayers._layers.some(
      (x: any) => x.imageryProvider === wms.wms,
    );
    if (isFound) {
      const imageryLayerToRemove = cesiumElement.imageryLayers._layers.find(
        (x: any) => x.imageryProvider === wms.wms,
      );
      let imageryLayerIndex =
        cesiumElement.imageryLayers.indexOf(imageryLayerToRemove);

      // Check if the imagery layer is found
      if (imageryLayerIndex !== -1) {
        // Remove the imagery layer from the collection
        cesiumElement.imageryLayers.remove(imageryLayerToRemove);
      } else {
        console.error('Imagery layer not found in the collection.');
      }
    }
    setLayersDisplayed(layersDisplayed.filter((x) => x.wms !== wms.wms));
  };

  return (
    <Accordion
      defaultExpanded={true}
      expanded={wms.isExpanded}
      onChange={() => handleCollapse()}
      sx={{
        wrap: 'nowrap',
        overflow: 'hidden',
        mt: 1,
        borderRadius: 0.5,
      }}
    >
      <AccordionSummary
        aria-controls="panel1a-content"
        id="panel1a-header"
        sx={{ overflow: 'hidden', borderRadius: 20 }}
      >
        <Grid
          container>
          <Grid xs={12} sx={{ textAlign: "center" }}>{wms.name}</Grid>
          <Grid item sx={{ width: 48, textAlign: 'center' }} xs={4}>
            <IconButton aria-label="visibility" onClick={handleVisibility}>
              {isVisible ? <VisibilityIcon sx={{ color: 'primary.main' }} /> : <VisibilityOffIcon />}
            </IconButton>
          </Grid>

          <Grid item sx={{ width: 48, textAlign: 'center' }} xs={4}>
            <IconButton aria-label="zoom" onClick={zoomTo} sx={{ color: 'primary.main' }}>
              <ZoomInIcon />
            </IconButton>
          </Grid>

          <Grid item sx={{ width: 48, textAlign: 'center' }} xs={4}>
            <IconButton aria-label="delete" sx={{ color: 'error.main' }} onClick={(e) => removeLayer(e, wms)}>
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Divider sx={{ mb: 1 }} />
        <Button fullWidth sx={{}}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
            }}
          >
            opacity ({opacity}) %
            <Slider
              size="small"
              max={100}
              onChange={(e: any) => handleChange(e.target.value, e)}
              defaultValue={opacity}
              aria-label="Slider"
              valueLabelDisplay="auto"
              onMouseDown={(e) => e.stopPropagation()}
            />
          </Box>
        </Button>
        <Box sx={{ mt: 1 }}>
          {wms.isExpanded && <img src={wms.wms.legend} alt="legend" />}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

interface WmsCardsProps {
  items?: any[];
}

export default function WmsCards({ items }: WmsCardsProps) {
  return (
    <Box sx={{ width: '100%' }}>
      {items && items.length > 0 ? (
        items.map((wms: any) => <WmsCard key={wms.id} wms={wms} />)
      ) : (
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            No WMS layers available.
          </Typography>
        </Box>
      )}
    </Box>
  );
}
